export const ASSISTANT_UPLOAD_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
] as const;

export type AssistantUploadMimeType =
  (typeof ASSISTANT_UPLOAD_MIME_TYPES)[number];

export const ASSISTANT_UPLOAD_MAX_BYTES = 10 * 1024 * 1024;

const isAcceptedMime = (type: string): type is AssistantUploadMimeType =>
  (ASSISTANT_UPLOAD_MIME_TYPES as readonly string[]).includes(type);

/**
 * Pure validation — exported for tests / extracted helpers. Returns null on
 * acceptance, an error message on rejection.
 */
export function validateAssistantUploadFile(file: File): string | null {
  if (!isAcceptedMime(file.type)) {
    return 'Only JPG, PNG, and WebP images are supported.';
  }
  if (file.size > ASSISTANT_UPLOAD_MAX_BYTES) {
    return 'Image must be under 10 MB.';
  }
  return null;
}

export const ASSISTANT_CLIP_UPLOAD_MIME_TYPES = [
  'video/mp4',
  'video/quicktime',
  'video/webm',
] as const;

export type AssistantClipMimeType =
  (typeof ASSISTANT_CLIP_UPLOAD_MIME_TYPES)[number];

export const ASSISTANT_CLIP_UPLOAD_MAX_BYTES = 600 * 1024 * 1024; // 600 MB

const isAcceptedClipMime = (type: string): type is AssistantClipMimeType =>
  (ASSISTANT_CLIP_UPLOAD_MIME_TYPES as readonly string[]).includes(type);

export function validateAssistantClipUploadFile(file: File): string | null {
  if (!isAcceptedClipMime(file.type)) {
    return 'Only MP4, MOV, and WebM clips are supported.';
  }
  if (file.size > ASSISTANT_CLIP_UPLOAD_MAX_BYTES) {
    return 'Clip must be under 600 MB.';
  }
  return null;
}
export function validateAdCreativeFile(file: File): string | null {
  return file.type.startsWith('video/')
    ? validateAssistantClipUploadFile(file)
    : validateAssistantUploadFile(file);
}
